import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_shq8vnOZnEXN: {
	id: 'prd_shq8v2DEV2nOZnEXN'
	ident: 'prd_shq8vnOZnEXN'
	sku: 'simple_premium_1w_4_15_1m_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_W3z9I2DEV2CoX7f62'
			amount: 22
			amount_usd: 4.15
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.15
			discount: 17.85
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_PCzDr2DEV2EB0unka'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_shq8vnOZnEXN, SubscriptionProduct>
const prd_shq8vnOZnEXN = { ident: 'prd_shq8vnOZnEXN' } as typeof _prd_shq8vnOZnEXN

export default prd_shq8vnOZnEXN
